module.exports = __webpack_public_path__ + "static/media/federatieveiligNL.dbf8318e.png";